exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbox[data-v-e159847c]{top:-20px;left:-4px}", ""]);

// exports
